import Tools from './tools.js'

export class UU5Json {
  constructor(json) {
    this._innerJson = json;
    this._value = Tools.parseFromUu5JSON(json);
  }
  get innerJson() {return this._innerJson}
  set innerJson(json) {
    if (this._innerJson !== json) {
      this._value = Tools.parseFromUu5JSON(json);
      this._innerJson = json;
    }
  }
  get value() {
    return this._value;
  }
  getClass() {
    return this.constructor.name;
  }
  clone() {
    return new UU5Json(this._innerJson);
  }
}

export default UU5Json;


// WEBPACK FOOTER //
// ./common/uu5-json.js